import { render, staticRenderFns } from "./JSelectKaoshiShijianduan.vue?vue&type=template&id=2d799400&scoped=true"
import script from "./JSelectKaoshiShijianduan.vue?vue&type=script&lang=js"
export * from "./JSelectKaoshiShijianduan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d799400",
  null
  
)

export default component.exports